<div class="report-dialog" [class.drag-over]="dragOver && !createdKey" (paste)="onPaste($event)" (drop)="onDrop($event)">
    <div class="dialog-header">
        <div class="dialog-header-icon" [class.dialog-header-icon--success]="createdKey">
            <mat-icon>{{ createdKey ? 'check' : 'support_agent' }}</mat-icon>
        </div>
        <div class="dialog-header-text">
            <h2 class="dialog-title" id="report-problem-title">
                {{ (createdKey ? 'components.report-problem-dialog.success.title' : 'components.report-problem-dialog.title') | translate }}
            </h2>
            <div class="dialog-subtitle" *ngIf="!createdKey">
                <ng-container *ngIf="!editingModule; else moduleSelect">
                    <span>{{ 'components.report-problem-dialog.context.you-are-in' | translate }}</span>
                    <strong>{{ selectedModule.label }}</strong>
                    <span aria-hidden="true">·</span>
                    <button type="button" class="link-button" [disabled]="submitting" (click)="editingModule = true">
                        {{ 'components.report-problem-dialog.context.change' | translate }}
                    </button>
                </ng-container>
                <ng-template #moduleSelect>
                    <select
                        class="module-select"
                        [attr.aria-label]="'components.report-problem-dialog.context.module-label' | translate"
                        [disabled]="submitting"
                        (change)="selectModule($any($event.target).value)"
                    >
                        <option *ngFor="let module of snapshot.modules" [value]="module.key" [selected]="module.key === selectedModuleKey">{{ module.label }}</option>
                    </select>
                </ng-template>
            </div>
        </div>
        <button type="button" class="close-btn" [disabled]="submitting" [attr.aria-label]="'components.report-problem-dialog.actions.close' | translate" (click)="requestClose()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Form -->
    <ng-container *ngIf="!createdKey; else success">
        <div class="dialog-body">
            <div class="field">
                <label class="field-label" for="report-problem-description">{{ 'components.report-problem-dialog.description.label' | translate }}</label>
                <textarea
                    id="report-problem-description"
                    class="field-textarea"
                    rows="4"
                    maxlength="5000"
                    aria-required="true"
                    [formControl]="description"
                    [placeholder]="'components.report-problem-dialog.description.placeholder' | translate"
                ></textarea>
            </div>

            <app-report-attachments
                [disabled]="submitting"
                (attachmentsChanged)="onAttachmentsChanged($event)"
                (uploadingChange)="attachmentsUploading = $event"
                (dragOverChange)="dragOver = $event"
            ></app-report-attachments>

            <div class="urgent-row" [class.urgent-row--checked]="blocking.value">
                <mat-checkbox class="urgent-checkbox" [formControl]="blocking">
                    <span class="urgent-label">{{ 'components.report-problem-dialog.urgent.label' | translate }}</span>
                    <span class="urgent-hint">{{ 'components.report-problem-dialog.urgent.hint' | translate }}</span>
                </mat-checkbox>
            </div>

            <p class="auto-info-notice">
                <mat-icon>info_outline</mat-icon>
                <span>{{ 'components.report-problem-dialog.auto-info.notice' | translate }}</span>
            </p>

            <div class="submit-error" role="alert" *ngIf="submitError">
                <mat-icon>error_outline</mat-icon>
                <span>{{ 'components.report-problem-dialog.error' | translate }}</span>
            </div>
        </div>

        <div class="dialog-footer">
            <span class="uploading-hint" *ngIf="attachmentsUploading">{{ 'components.report-problem-dialog.attachments.uploading' | translate }}</span>
            <button type="button" class="btn-cancel" [disabled]="submitting" (click)="requestClose()">
                {{ 'components.report-problem-dialog.actions.cancel' | translate }}
            </button>
            <button type="button" class="btn-primary send-button" [disabled]="!canSubmit" (click)="submit()">
                <mat-spinner *ngIf="submitting" diameter="16"></mat-spinner>
                <span>{{ 'components.report-problem-dialog.actions.send' | translate }}</span>
            </button>
        </div>
    </ng-container>

    <!-- Confirmation -->
    <ng-template #success>
        <div class="dialog-body report-problem__success" role="status" aria-live="polite">
            <p class="success-reference">{{ 'components.report-problem-dialog.success.reference' | translate: { key: createdKey } }}</p>
            <p class="success-hint">{{ 'components.report-problem-dialog.success.hint' | translate }}</p>
        </div>
        <div class="dialog-footer">
            <button #closeButton type="button" class="btn-primary" (click)="requestClose()">
                {{ 'components.report-problem-dialog.actions.close' | translate }}
            </button>
        </div>
    </ng-template>
</div>
